import { Reveal } from "@/components/Reveal";

const stats = [
  { value: "10", label: "Service practices" },
  { value: "5 days", label: "Baseline review turnaround" },
  { value: "6", label: "Compliance frameworks" },
  { value: "20 min", label: "Free consult, always" },
];

export function Stats() {
  return (
    <section className="bg-black py-20 border-t border-white/10" data-testid="stats">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
        {stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div className="bg-black p-8 lg:p-10 h-full" data-testid={`stat-${i}`}>
              <div className="font-display text-4xl lg:text-6xl tracking-tighter text-paper">{s.value}</div>
              <div className="mt-3 text-xs uppercase tracking-widest text-fog">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
